<div>
    <h2>{{'ACCESSIBILITY.TITLE_ACCESSIBILITY' | translate}}</h2>
    <hr>
    <p [innerHTML]="'ACCESSIBILITY.TEXT1_ACCESSIBILITY' | translate:{eclectusUrl: eclectusUrl}"></p>
    <h3 class="fr-h5">{{'ACCESSIBILITY.TITLE_CONFORMITY' | translate}}</h3>
    <p>{{'ACCESSIBILITY.TEXT_CONFORMITY' | translate}}</p>
    <h3 class="fr-h5">{{'ACCESSIBILITY.TITLE_INFO_CONTACT' | translate}}</h3>
    <p [innerHTML]="'ACCESSIBILITY.TEXT_INFO_CONTACT' | translate:{mailContact: mailContact}"></p>
    <h3 class="fr-h5">{{'ACCESSIBILITY.TITLE_RECOURSE' | translate}}</h3>
    <p>{{'ACCESSIBILITY.TEXT1_RECOURSE' | translate}}</p>
    <ul>
        <li [innerHTML]="'ACCESSIBILITY.TEXT2_RECOURSE' | translate:{defenderContactLink: defenderContactLink}"></li>
        <li [innerHTML]="'ACCESSIBILITY.TEXT3_RECOURSE' | translate:{defenderMapLink: defenderMapLink}"></li>
        <li>{{'ACCESSIBILITY.TEXT4_RECOURSE' | translate}}</li>
        <li>
            {{'ACCESSIBILITY.TEXT5_RECOURSE' | translate}}
            <br/>{{'ACCESSIBILITY.TEXT6_RECOURSE' | translate}}
            <br/>{{'ACCESSIBILITY.TEXT7_RECOURSE' | translate}}
            <br/>{{'ACCESSIBILITY.TEXT8_RECOURSE' | translate}}
        </li>
    </ul>
</div>
